"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var irishPointsIdx = [
// there is no 0 placement, but the array is 0-indexed. Prevents
// irishPointsIdx[ placement - 1 ] junk.
null,

// The rest are just the pre-defined placements.
100, 75, 65, 60, 56, 53, 50, 47, 45, 43, 41, 39, 38, 37, 36, 35, 34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

var getPlacementsForRound = exports.getPlacementsForRound = function getPlacementsForRound(event, participants) {
  // Oireachtas method
  // Ties should have the same placement, with the following competitor skipping a placement. E.g.
  // if two people tie for 1st, both get 1 and the next best person gets 3.
  if (event.type === "C") {
    participants.forEach(function (person, idx) {
      participants.forEach(function (p2) {
        if (p2.placement === undefined && p2.value === person.value) {
          p2.placement = idx + 1;
        }
      });
      if (person.placement === undefined) {
        person.placement = idx + 1;
      }
    });
    // Don't skip placements in instances of ties in all other competitions
    // If two people tie for 1st, both get 1 and the next best person gets 2.
  } else {
    var currentPlacement = 1;
    var placements = [];
    participants.forEach(function (person) {
      if (person.placement === undefined) {
        if (placements[person.value]) {
          person.placement = placements[person.value];
        } else {
          person.placement = currentPlacement;
          placements[person.value] = currentPlacement;
          currentPlacement++;
        }
      }
    });
  }
};

var deriveNumberPlaced = exports.deriveNumberPlaced = function deriveNumberPlaced() {
  var participantsTotal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var nafcMinimum = getNafcMinimum(participantsTotal);
  // If there is a user-provided value, place the specified number of competitors.
  var numPlaced = void 0;
  if (event.place_cnt) {
    numPlaced = event.place_cnt;
  } else if (event.place_pct) {
    numPlaced = Math.ceil(participantsTotal * event.place_pct / 100.0);
  } else if (event.nafc_or_place_pct) {
    if (Math.ceil(participantsTotal * event.nafc_or_place_pct / 100.0) < nafcMinimum) {
      numPlaced = nafcMinimum;
    } else {
      numPlaced = Math.ceil(participantsTotal * event.nafc_or_place_pct / 100.0);
    }
  } else if (event.nafc_or_place_cnt) {
    if (event.nafc_or_place_cnt < nafcMinimum) {
      numPlaced = nafcMinimum;
    } else {
      numPlaced = event.nafc_or_place_cnt;
    }
  } else if (!numPlaced || numPlaced < nafcMinimum) {
    numPlaced = nafcMinimum;
  }

  return numPlaced;
};

var getNafcMinimum = function getNafcMinimum() {
  var participantsTotal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var nafcMinimum = void 0;

  // Determine the minimum number of placements.
  if (participantsTotal < 5) {
    nafcMinimum = Math.min(4, participantsTotal);
  } else if (participantsTotal === 5) {
    nafcMinimum = 3;

    // For any greater than 5, we place 3, plus 1 for each additional 5 competitors.
  } else {
    nafcMinimum = 3 + Math.ceil((participantsTotal - 5) / 5.0);
  }
  return nafcMinimum;
};

var Scores = function () {
  function Scores(event, persons) {
    _classCallCheck(this, Scores);

    this._event = event;
    this._persons = persons;

    // There is one scoresheet per adjudicator per competition.
    this.scoresheets = [];
  }

  _createClass(Scores, [{
    key: "usesIrishPoints",
    value: function usesIrishPoints() {
      return this._event.irish_points === 1;
    }
  }, {
    key: "numPlaced",
    value: function numPlaced() {
      return this.num_placed || 0;
    }
  }, {
    key: "addScoresheet",
    value: function addScoresheet(scores) {
      var scoresheet = { scores: scores };
      this.scoresheets.push(scoresheet);
      this._processScores(scoresheet);

      return this;
    }
  }, {
    key: "calculate",
    value: function calculate() {
      this._calculateResults();
      return this.participants;
    }
  }, {
    key: "refreshScoresheet",
    value: function refreshScoresheet(scoresheet) {
      this._processScores(scoresheet);
      return this.calculate();
    }
  }, {
    key: "_placeByTotal",
    value: function _placeByTotal(scoresheet) {
      var ties = {};

      var placements = scoresheet.placements = [].concat(scoresheet.scores).sort(function (a, b) {
        return a.total - b.total;
      }).reverse();

      placements.forEach(function (p) {
        return delete p.placement;
      });
      if (this._event.type === "C") {

        placements.forEach(function (person, idx) {
          if (!ties[idx + 1]) {
            ties[idx + 1] = [];
          }

          placements.forEach(function (p2, i2) {
            if (p2.placement === undefined && p2.total === person.total) {
              p2.placement = idx + 1;
              ties[idx + 1].push(p2);
            }
          });

          if (person.placement === undefined) {
            person.placement = idx + 1;
            ties[idx + 1].push(p2);
          }
        });
      } else {
        var currentPlacement = 1;

        placements.forEach(function (person) {
          if (ties[currentPlacement] && ties[currentPlacement][0].total === person.total) {
            person.placement = currentPlacement;
            ties[currentPlacement].push(person);
          } else if (ties[currentPlacement]) {
            person.placement = ++currentPlacement;
            ties[currentPlacement] = [person];
          } else {
            person.placement = currentPlacement;
            ties[currentPlacement] = [person];
          }
        });
      }

      return ties;
    }
  }, {
    key: "_processScores",
    value: function _processScores(scoresheet) {
      var _this = this;

      scoresheet.scores.forEach(function (person) {
        // Sum all the rounds together.
        person.total = person.scores.map(function (s) {
          return s.value;
        }).reduce(function (a, b) {
          return a + b;
        });

        // For each score in each scoresheet, store the original competitor number so we'll know if it
        // changed.
        person.$origCompetitor = person.competitor;
      });

      // Calculate placements.
      var ties = this._placeByTotal(scoresheet);

      // Convert placements to irish points, if we need to.
      scoresheet.scores.forEach(function (person) {
        if (_this.usesIrishPoints()) {
          // The default number of points is always 0.
          person.computedTotal = irishPointsIdx[person.placement] || 0;
        } else {
          person.computedTotal = person.total;
        }
      });

      // Average the Irish Points for ties
      var score;
      var place;
      if (this.usesIrishPoints()) {
        Object.keys(ties).forEach(function (p) {
          place = parseInt(p, 10);
          if (ties[place].length > 1) {
            score = irishPointsIdx.slice(place, ties[place].length + place).reduce(function (a, b) {
              return a + b;
            });
            score = score / ties[place].length;

            ties[place].forEach(function (p) {
              return p.computedTotal = score;
            });
          }
        });
      }

      return scoresheet;
    }
  }, {
    key: "_calculateResults",
    value: function _calculateResults() {
      var _this2 = this;

      // Calculate totals across scoresheets
      var persons = {};

      this.scoresheets.forEach(function (scoresheet) {
        scoresheet.scores.forEach(function (score) {
          if (!persons[score.person]) {
            persons[score.person] = {
              total: 0,
              computedTotal: 0,
              scores: {}
            };
          }

          persons[score.person].scores[score.scores[0].adjudicator] = score;
          persons[score.person].total += score.total;
          persons[score.person].computedTotal += score.computedTotal;
        });
      });

      // Put them in placement order.
      this.participants = this._persons.map(function (a) {
        var p = JSON.parse(JSON.stringify(a));
        if (persons[p.id]) {
          p.scores = persons[p.id].scores;
          p.total = persons[p.id].total;
          p.computedTotal = persons[p.id].computedTotal;
          delete persons[p.id];
        }

        return p;
      });

      this.nonparticipants = this.participants.filter(function (p) {
        return !p.total;
      });

      this.participants = this.participants.filter(function (p) {
        return p.computedTotal;
      }).sort(function (a, b) {
        return a.computedTotal - b.computedTotal;
      }).reverse();

      // Assign a placement number, handling ties as necessary.
      this.participants.forEach(function (p) {
        return delete p.placement;
      });

      // Oireachtas method
      // Ties should have the same placement, with the following competitor skipping a placement. E.g.
      // if two people tie for 1st, both get 1 and the next best person gets 3.
      if (this._event.type === "C") {
        this.participants.forEach(function (person, idx) {
          _this2.participants.forEach(function (p2) {
            if (p2.placement === undefined && p2.computedTotal === person.computedTotal) {
              p2.placement = idx + 1;
            }
          });

          if (person.placement === undefined) {
            person.placement = idx + 1;
          }
        });
        // Don't skip placements in instances of ties in all other competitions
        // If two people tie for 1st, both get 1 and the next best person gets 2.
      } else {
        var currentPlacement = 1;
        var placements = [];
        this.participants.forEach(function (person) {
          if (person.placement === undefined) {
            if (placements[person.computedTotal]) {
              person.placement = placements[person.computedTotal];
            } else {
              person.placement = currentPlacement;
              placements[person.computedTotal] = currentPlacement;
              currentPlacement++;
            }
          }
        });
      }

      // Determine the number of competitors with a score.
      var competitors = this.participants.filter(function (p) {
        return p.computedTotal;
      }).length;

      var nafcMinimum = void 0;

      // Determine the minimum number of placements.
      if (competitors < 5) {
        nafcMinimum = Math.min(4, competitors);
      } else if (competitors === 5) {
        nafcMinimum = 3;

        // For any greater than 5, we place 3, plus 1 for each additional 5 competitors.
      } else {
        nafcMinimum = 3 + Math.ceil((competitors - 5) / 5.0);
      }

      // If there is a user-provided value, place the specified number of competitors.
      if (this._event.place_cnt) {
        this.num_placed = this._event.place_cnt;
      } else if (this._event.place_pct) {
        this.num_placed = Math.ceil(competitors * this._event.place_pct / 100.0);
      } else if (this._event.nafc_or_place_pct) {
        if (Math.ceil(competitors * this._event.nafc_or_place_pct / 100.0) < nafcMinimum) {
          this.num_placed = nafcMinimum;
        } else {
          this.num_placed = Math.ceil(competitors * this._event.nafc_or_place_pct / 100.0);
        }
      } else if (this._event.nafc_or_place_cnt) {
        if (this._event.nafc_or_place_cnt < nafcMinimum) {
          this.num_placed = nafcMinimum;
        } else {
          this.num_placed = this._event.nafc_or_place_cnt;
        }
      } else if (!this.num_placed || this.num_placed < nafcMinimum) {
        this.num_placed = nafcMinimum;
      }

      // Mark any competitors that are above the correct number of placements
      for (var i = 0; i < this.participants.length; i++) {
        if (i + 1 <= this.num_placed || this.participants[i - 1].placed && this.participants[i - 1].placement === this.participants[i].placement) {
          this.participants[i].placed = 1;
        } else {
          this.participants[i].placed = 0;
        }
      }
    }
  }]);

  return Scores;
}();

exports.default = Scores;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/utilities/scores.js
// module id = 250
// module chunks = 0